module.exports = __webpack_public_path__ + "static/media/A4F579F9-DD2B-42CD-989D-2DAF076DC72C.01a51607.JPG";